<template>
  <EditorContent
    class="editor-content px-4 py-4"
    :class="{ 'min-h-60': editor?.isEditable }"
    :editor="editor"
  />
</template>
<script setup lang="ts">
import { Editor, EditorContent } from '@tiptap/vue-3';

defineProps({
  editor: {
    type: Editor,
    default: null,
  },
});
</script>

<style>
.tiptap ul {
  @apply ps-5;
  list-style: inside;
}

.tiptap ol {
  @apply ps-5;
  list-style: decimal;
}

.tiptap ol li {
  list-style-position: inside;
}

.tiptap ul h1,
.tiptap ul h2,
.tiptap ul h3,
.tiptap ul h4,
.tiptap ul h5,
.tiptap ul h6,
.tiptap ul p,
.tiptap ol h1,
.tiptap ol h2,
.tiptap ol h3,
.tiptap ol h4,
.tiptap ol h5,
.tiptap ol h6,
.tiptap ol p {
  display: inline;
  /* text-align: inherit; */
}

.tiptap a {
  display: inline-block;
}

blockquote {
  @apply flex flex-col;
  font-style: italic;
  padding: 20px;
  margin: 16px 0;
  position: relative;
}

blockquote > * {
  @apply !mb-1 px-5 relative w-fit;
  text-align: inherit !important;
}
blockquote > *:not(hr):first-of-type::before {
  content: '';
  background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiM2Nzc2OEUiIHN0cm9rZS13aWR0aD0iMS4yNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0ibHVjaWRlIGx1Y2lkZS1xdW90ZSI+PHBhdGggZD0iTTE2IDNhMiAyIDAgMCAwLTIgMnY2YTIgMiAwIDAgMCAyIDIgMSAxIDAgMCAxIDEgMXYxYTIgMiAwIDAgMS0yIDIgMSAxIDAgMCAwLTEgMXYyYTEgMSAwIDAgMCAxIDEgNiA2IDAgMCAwIDYtNlY1YTIgMiAwIDAgMC0yLTJ6Ii8+PHBhdGggZD0iTTUgM2EyIDIgMCAwIDAtMiAydjZhMiAyIDAgMCAwIDIgMiAxIDEgMCAwIDEgMSAxdjFhMiAyIDAgMCAxLTIgMiAxIDEgMCAwIDAtMSAxdjJhMSAxIDAgMCAwIDEgMSA2IDYgMCAwIDAgNi02VjVhMiAyIDAgMCAwLTItMnoiLz48L3N2Zz4=');
  background-repeat: no-repeat;
  background-size: contain;
  font-size: 2em;
  width: 0.5em;
  height: 0.5em;
  position: absolute;
  inset-inline-start: -10px;
  top: -15px;
  line-height: 0.1em;
  transform: scaleX(1);
}

blockquote > *:not(hr):last-of-type::after {
  content: '';
  background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiM2Nzc2OEUiIHN0cm9rZS13aWR0aD0iMS4yNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0ibHVjaWRlIGx1Y2lkZS1xdW90ZSI+PHBhdGggZD0iTTE2IDNhMiAyIDAgMCAwLTIgMnY2YTIgMiAwIDAgMCAyIDIgMSAxIDAgMCAxIDEgMXYxYTIgMiAwIDAgMS0yIDIgMSAxIDAgMCAwLTEgMXYyYTEgMSAwIDAgMCAxIDEgNiA2IDAgMCAwIDYtNlY1YTIgMiAwIDAgMC0yLTJ6Ii8+PHBhdGggZD0iTTUgM2EyIDIgMCAwIDAtMiAydjZhMiAyIDAgMCAwIDIgMiAxIDEgMCAwIDEgMSAxdjFhMiAyIDAgMCAxLTIgMiAxIDEgMCAwIDAtMSAxdjJhMSAxIDAgMCAwIDEgMSA2IDYgMCAwIDAgNi02VjVhMiAyIDAgMCAwLTItMnoiLz48L3N2Zz4=');
  background-repeat: no-repeat;
  background-size: contain;
  font-size: 2em;
  width: 0.5em;
  height: 0.5em;
  position: absolute;
  inset-inline-end: -10px;
  bottom: -15px;
  line-height: 0.1em;
  transform: scaleX(-1);
}

*:has([dir='ltr']) > blockquote > *:first-child::before,
.preview-wrapper[dir='ltr'] blockquote > *:first-child::before,
.block[dir='ltr'] blockquote > *:first-child::before,
blockquote > *[dir='ltr']:first-child::before {
  transform: rotate(180deg);
}
*:has([dir='ltr']) > blockquote > *:last-child::after,
.preview-wrapper[dir='ltr'] blockquote > *:last-child::after,
.block[dir='ltr'] blockquote > *:last-child::after,
blockquote > *[dir='ltr']:last-child::after {
  transform: rotate(0deg);
}

*:has([dir='rtl']) .handwriting,
.preview-wrapper[dir='rtl'] .handwriting,
.block[dir='rtl'] .handwriting,
*:has([dir='rtl']) .handwriting *,
.preview-wrapper[dir='rtl'] .handwriting *,
.block[dir='rtl'] .handwriting *,
.handwriting,
.handwriting * {
  font-family: FbLiddarBold, SpringsNoteRegular, sans-serif;
}

*:has([dir='ltr']) .handwriting,
.preview-wrapper[dir='ltr'] .handwriting,
.bRichTextEditorlock[dir='ltr'] .handwriting,
*:has([dir='ltr']) .handwriting *,
.preview-wrapper[dir='ltr'] .handwriting *,
.block[dir='ltr'] .handwriting * {
  font-family: SpringsNoteRegular, FbLiddarBold, sans-serif;
}

.handwriting strong {
  @apply font-springsNoteBold;
}

.tooltip-text {
  @apply text-pink-500;
}

.preview-wrapper .tooltip-text {
  @apply !text-lime-500;
}

.tooltip {
  @apply absolute text-white rounded-md px-3 py-1.5 bg-secondary-900 text-xs;
}

.tooltip::after {
  @apply absolute -top-1.2 left-1/2 -translate-x-1/2 border-l-5 border-l-transparent border-r-5 border-r-transparent border-b-5 border-b-secondary-900;
  content: '';
}

.ProseMirror {
  @apply ring-0 outline-none focus:ring-0 focus:outline-none p-0 py-1;
}

.ProseMirror-focused {
  box-shadow: none !important;
  outline: none !important;
  outline-offset: 0;
  --tw-ring-offset-shadow: none;
  --tw-ring-shadow: none;
}
.viewer .ProseMirror {
  @apply min-h-50;
}
.editor-content {
  width: 100%;
}

.editor-content *.is-editor-empty:first-child::before {
  color: #adb5bd;
  content: attr(data-placeholder);
  float: right;
  height: 0;
  pointer-events: none;
}
.editor-content *[textalign='center'].is-editor-empty:first-child::before {
  width: 100%;
}

.hover-menu .options-menu {
  @apply pb-0 border-0;
}
.hover-menu .options-menu div {
  @apply p-0;
}

html[dir='ltr'] .editor-content *.is-editor-empty:first-child::before,
.preview-wrapper[dir='ltr'] *.is-editor-empty:first-child::before,
.block[dir='ltr'] *.is-editor-empty:first-child::before {
  float: left;
}

p[data-placeholder] {
  @apply !body;
}

.ProseMirror p span {
  position: relative;
}

.ProseMirror *:not(blank):not(table):has(.katex-string) {
  display: inline-flex !important;
  align-items: center;
  flex-wrap: wrap;
  overflow: hidden;
  white-space: normal;
  overflow-wrap: break-word;
  word-break: break-word;
  gap: 2px;
  width: 100%;
}

.ProseMirror span:not(blank):has(.katex-string),
.ProseMirror mark:not(blank):has(.katex-string) {
  width: auto;
}

*:has(.katex-string) img.ProseMirror-separator {
  height: 18px !important;
  margin-bottom: 10px;
}

.collaboration-cursor__label {
  border-radius: 3px 3px 3px 0;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  padding: 0.1rem 0.3rem;
  position: absolute;
  top: -1.4em;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  white-space: nowrap;
}

.collaboration-cursor__label[dir='ltr'] {
  right: -1px;
}

.collaboration-cursor__label[dir='rtl'] {
  left: -1px;
}

.ML__content {
  min-width: 100px !important;
}
:root {
  --keyboard-padding-horizontal: 3rem;
  --keyboard-zindex: 999999999999999999999;
  --keycap-height: 40px;
  --keycap-font-size: 17px;
  --keyboard-background: #cbcfd6;
  --keyboard-accent-color: #0fa9ff;
  --keyboard-toolbar-text: #495465;
  --keyboard-toolbar-text-active: #0fa9ff;
  --keyboard-toolbar-background: #cbcfd6;
  --keyboard-toolbar-background-hover: #cbcfd6;
  --keyboard-toolbar-background-selected: #cbcfd6;
  /* Keycaps (General) */
  --keycap-background: #ffffff;
  --keycap-text: #000;
  --keycap-primary-text: #000;
  --keycap-text-hover: #2b313b;
  --keycap-background-hover: #f7f9fd;
  --keycap-text-active: #f7f9fd;
  --keycap-background-active: #0fa9ff;
  --keycap-text-pressed: #f7f9fd;
  --keycap-background-pressed: #0fa9ff;
  --keycap-shift-color: #ffffff;
  --box-placeholder-color: #cbcfd6;
  --variant-panel-background: #ffffff;
  --variant-panel-keycap-background: red;
  --keycap-secondary-background: #444444;
  --keycap-secondary-background-hover: #555555;
  --keycap-secondary-text: #ffffff;
  --variant-keycap-text: #495465;
  --variant-keycap-text-active: #f7f9fd;
  --variant-keycap-background-active: #0fa9ff;
  --keycap-border: 0px solid #444444;
  --keycap-border-bottom: 0px solid #666666;
  --keycap-shift-text: #fff;
  /* Primary & Secondary Keycaps */
  --keycap-primary-background: red;
  --keycap-primary-background-hover: #292929;
  --keycap-secondary-border: 1px solid #666666;
  --keycap-secondary-border-bottom: 2px solid #888888;
}
.ML__keyboard {
  direction: ltr;
  z-index: 999999999999999999999999 !important;
}
.MLK__backdrop {
  pointer-events: auto;
  min-height: 300px;
}
.ML__edit-toolbar {
  display: none !important;
}
.MLK__rows {
  max-width: 996px;
  align-self: center;
}
.ML__latex {
  line-height: 0;
}
.MLK__keycap {
  font-family: system-ui;
}
.has-variant::before {
  content: '';
  position: absolute;
  top: 4px;
  right: 4px;
  width: 0;
  height: 0;
  border-bottom: 12px solid transparent;
  border-left: 12px solid transparent;
  border-right: 12px solid #0fa9ff;
}

.digital {
  background-color: #f1f2f4;
  color: #000;
}
.symbol {
  line-height: 0 !important;
  display: flex;
  align-items: center;
}
.extra-small {
  font-size: 10px !important;
}
.action.warning svg {
  padding: 0px;
  margin: 0px;
}

.word-span:last-child {
  flex-grow: 1;
  text-align: start;
}

p:has(.tiptap-placeholder),
label:has(.tiptap-placeholder),
h3:has(.tiptap-placeholder) {
  margin: 0 !important;
  display: flex;
  justify-items: center;
}
.tiptap-placeholder {
  position: sticky;
  top: 0;
  opacity: 0.5;
  pointer-events: none;
  height: 100%;
  width: 100%;
  font-size: 14px;
  @apply text-secondary-800;
}

.tiptap-placeholder p {
  font-size: 14px !important;
  margin: 0 !important;
}

.preview-wrapper:has(.tiptap-placeholder) .ProseMirror-separator {
  position: absolute;
  top: calc(50% - 8px);
}
</style>
